export const basicControlStyle = 'rounded shadow focus:opacity-100 focus:shadow'

export const activeControlStyle = 'text-accent-primary-500 bg-accent-600 hover:bg-accent-700'

export const inactiveControlStyle = ''
